// PublicRoute.js
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { roleToPath } from '../constants/constant';

const PublicRoute = () => {
    const { user } = useSelector((state) => state.auth);

    const isAuthenticated = !!user;

    // ✅ Redirect to role-based dashboard if already logged in
    if (isAuthenticated && user.role) {
        return <Navigate to={roleToPath[user.role] || "/not-authorized"} replace />;
    }

    // ✅ Else render login/public content
    return <Outlet />;
};
//     const userData = localStorage.getItem('user');

//     const user = JSON.parse(JSON.stringify(userData));   

//    // console.log("PublicRoute", user);

//     return user ? <Navigate to="/dashboard" /> : <Outlet />;

export default PublicRoute;
